




















import Vue from 'vue';
import PasswordProtection from '@/web/views/admin/PasswordProtection.vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { mapGetters } from 'vuex';
import { loadUserbackScript } from '@/web/utils/userback';
import store from '@/core/store';
import { getConfig } from '@/web/utils/configuration';
import HMDialog from '@/web/components/common/HMDialog.vue';
import { HMUpgradePlanModal } from '@/web/components/common';

export default Vue.extend({
  name: 'AdminTemplate',
  metaInfo() {
    return {
      title: getConfig().applicationName,
    };
  },
  components: {
    PasswordProtection,
    TopNav,
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      canAccessLockedPages: 'user/canAccessLockedPages',
      showUpgradeModal: 'user/showUpgradeModal',
      showUserbackInStudio: 'globals/showUserbackInStudio',
    }),
    showPasswordProtection() {
      return !this.canAccessLockedPages && this.$route.meta?.passwordProtected;
    },
  },
  mounted() {
    if (process.env.VUE_APP_USERBACK_DISPLAY_IN_ADMIN === 'true') {
      loadUserbackScript();
    }
    store.dispatch('studio/loadTranslations', this.teacherStudioUrl);
  },
  watch: {
    showUpgradeModal(show) {
      if (show) {
        this.$modal.show(
          HMUpgradePlanModal,
          {
            description: 'GENERAL.TEXT.FUNCTIONALITY_IS_NOT_AVAILABLE',
            onConfirm: () => {
              this.$modal.hideAll();
              this.$store.dispatch('user/showUpgradeModal', false);
              this.$router.push({ name: 'settings-adjust-plan' });
            },
            onDiscard: () => {
              this.$store.dispatch('user/showUpgradeModal', false);
            },
          },
          {
            clickToClose: false,
          }
        );
      }
    },
  },
});
